'use client';

import React, { Fragment, useEffect, useState } from 'react';
import * as S from './styles';
import Image from 'next/image';

import logo_chippu_place from '@/assets/logo_chippu_place.svg';
import { IconeMenu } from '@/components/atoms/Icones/IconeMenu';
import { useTheme } from 'styled-components';
import MenuLateralTemplate from '@/components/templates/MenuLateralTemplate';
import { IconeFechar } from '@/components/atoms/Icones/IconeFechar';
import Header from '@/components/atoms/Header';
import IconButton from '@/components/atoms/IconButton';
import { usePathname, useRouter } from 'next/navigation';
import { useSacola } from '@/hooks/useSacola';
import { useSession } from 'next-auth/react';
import HeaderMenuLateral from '@/components/templates/HeaderMenuLateral';
import Link from 'next/link';
import { CabecalhoHomeProps } from '../..';
import HeaderMenuLateralDeslogado from '@/components/organisms/HeaderMenuLateralDeslogado';
import HeaderMenuLateralLogado from '@/components/organisms/HeaderMenuLateralLogado';
import MenuLateralCorpo from '@/components/organisms/MenuLateralCorpo';
import SearchField from '@/components/molecules/SearchField';
import useCabecalhoHomeHook from '../../hook/useCabecalhoHomeHook';
import { registrarEvento } from '@/services/googleAnalytics';
import useResumoCompraHook from '@/components/organisms/ResumoCompra/hook/useResumoCompraHook';
import { IconeSacola } from '@/components/atoms/Icones/IconeSacola';

export default function CabecalhoHomeMobile(props: CabecalhoHomeProps) {
  const { $valorInputPesquisa, $setarValorInputPesquisa, $setarInputAtivo } =
    props;

  const [webView, setWebView] = useState(false);

  useEffect(() => {
    const usuarioWebView = localStorage.getItem('chippuPlace@AcessoAPPChippu');
    if (usuarioWebView) {
      setWebView(true);
    }
  }, []);

  const theme = useTheme();
  const router = useRouter();
  const caminhoURL = usePathname();

  const { status, data } = useSession();

  const { itens } = useSacola();
  const { valoresResumoCompra } = useResumoCompraHook();

  const {
    menuLateralAberto,
    lidarMenuLateral,
    distanciaTopoHeader,
    headerRef,
    inputContainerRef,
  } = useCabecalhoHomeHook();

  return (
    <Fragment>
      <MenuLateralTemplate
        $estaAberto={menuLateralAberto}
        $alturaToolBar={distanciaTopoHeader?.current}
        onClick={lidarMenuLateral}
      >
        {!webView ? (
          <HeaderMenuLateral $color="accent" $variant="translucent">
            {status !== 'authenticated' ? (
              <HeaderMenuLateralDeslogado
                $lidarMenuLateral={lidarMenuLateral}
              />
            ) : (
              <HeaderMenuLateralLogado
                $usuarioLogado={data?.user}
                $lidarMenuLateral={lidarMenuLateral}
              />
            )}
          </HeaderMenuLateral>
        ) : null}
        <MenuLateralCorpo
          $visualizacaoWebView={webView}
          $onClick={lidarMenuLateral}
        />
      </MenuLateralTemplate>
      <S.ContainerWrapper ref={headerRef}>
        <Header
          {...props}
          $style={
            caminhoURL === '/pagamento-cartao'
              ? { gap: 0 }
              : {
                  paddingRight: theme.spacing[4],
                  paddingLeft: theme.spacing[4],
                }
          }
        >
          <S.ToolBar>
            <IconButton
              $size={2}
              $variant="ghost"
              $color="neutral"
              $highContrast={true}
              $loading={false}
              $state="default"
              $focusRing={false}
              $Icon={menuLateralAberto ? IconeFechar : IconeMenu}
              $onClick={lidarMenuLateral}
            />
            <Link href="/" onClick={() => $setarValorInputPesquisa('')}>
              <Image
                src={logo_chippu_place}
                alt="Chippu Place logo"
                height={theme.typography.font.size[7]}
                priority
              />
            </Link>
            <IconButton
              $size={2}
              $variant="ghost"
              $color="neutral"
              $highContrast={true}
              $loading={false}
              $state="default"
              $focusRing={false}
              $Icon={IconeSacola}
              $onClick={() => {
                registrarEvento('view_cart', {
                  currency: 'BRL',
                  value: valoresResumoCompra?.valorTotal,
                  items: itens.map((itemSacola) => {
                    if (
                      itemSacola?.produto &&
                      itemSacola?.opcaoSelecionadaProduto
                    ) {
                      return {
                        item_id: itemSacola?.opcaoSelecionadaProduto?.id,
                        item_brand: itemSacola?.produto?.nome,
                        item_name: itemSacola?.opcaoSelecionadaProduto?.nome,
                        discount: itemSacola?.opcaoSelecionadaProduto?.desconto,
                        quantity: itemSacola.quantidade,
                      };
                    } else if (itemSacola?.plano) {
                      return {
                        item_id: itemSacola.plano.comboID,
                        item_name: itemSacola.plano.nome,
                        discount: itemSacola.plano.desconto,
                      };
                    }
                  }),
                });
                router.push('/sacola', { scroll: true });
              }}
              $textoBadge={
                itens.length == 0 ? undefined : itens.length.toString()
              }
            />
          </S.ToolBar>
          {caminhoURL !== '/pagamento-cartao' ? (
            <S.ContainerSearchField ref={inputContainerRef}>
              <SearchField
                onChange={(e) => {
                  $setarValorInputPesquisa(e?.target?.value);
                }}
                $size={1}
                $variant="surface"
                $state={
                  $valorInputPesquisa.length > 0 ? 'filled' : 'placeholder'
                }
                $label={false}
                $focusRing={false}
                $placeholder="Buscar por produto ou assinatura"
                $inputProps={{
                  value: $valorInputPesquisa,
                  onFocus: () => $setarInputAtivo(true),
                  onBlur: () => $setarInputAtivo(false),
                }}
              />
            </S.ContainerSearchField>
          ) : (
            <div ref={inputContainerRef} />
          )}
        </Header>
      </S.ContainerWrapper>
    </Fragment>
  );
}
